import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

// Layout for /timesheets/* — the week grid and the settings page nest under a
// common parent. Gates every child on `timesheet.view`; the settings page
// adds its own `timesheet.settings` gate for mutation.
export const Route = createFileRoute('/_authenticated/timesheets')({
  component: TimesheetsLayout,
});

function TimesheetsLayout() {
  const { permissions, loading } = useMe();
  if (!loading && !permissions.has('timesheet.view')) {
    return <NoAccess permission="timesheet.view" resource="Timesheets" />;
  }
  return <Outlet />;
}
